import { Component, computed, input, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { ShowCookieSettings } from '@teamfoster/sdk/cookie-ngrx';
import { FromDictionaryPipe } from '@teamfoster/sdk/dictionary-ngrx';
import { MenuItem, OfMenuTypePipe } from '@teamfoster/sdk/menu-ngrx';
import { JsonLdComponent } from 'src/app/seo/components/json-ld/json-ld.component';
import { SocialChannel } from 'src/app/social-media/models';
import { Department, Location } from 'src/app/location/models';
import { Button, LinkComponent } from '@teamfoster/sdk/button';
import { StructuredData } from 'src/app/seo';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  imports: [FromDictionaryPipe, JsonLdComponent, LinkComponent, OfMenuTypePipe],
})
export class FooterComponent {
  private store = inject(Store);
  private dict = new FromDictionaryPipe();

  domain = input<string>('');
  menu = input<MenuItem[]>([]);
  menuEnd = input<MenuItem[]>([]);
  menuMain = input<MenuItem[]>([]);
  socials = input<SocialChannel[]>([]);
  locations = input<Location[]>([]);

  schema = StructuredData.organization(this.socials);

  year = new Date().getFullYear();

  centralLocation$ = computed(() => {
    const locations = this.locations();

    return locations.find(l => l.id == 1); // 1 == id of central location
  });

  thisDayNumber$ = computed(() => new Date().getDay());

  openCookie() {
    this.store.dispatch(ShowCookieSettings());
  }

  getOpeningTime(department: Department) {
    const date = department?.openingTimes.find(a => a.day === this.thisDayNumber$());

    return date ? date.openingTimes : '- ';
  }

  buttonLink(menuItem: MenuItem): Button {
    return {
      text: menuItem.title,
      url: menuItem.url || '',
      routerLink: menuItem.routerLink,
      fragment: menuItem.fragment,
      queryParams: menuItem.queryParams,
    };
  }
}
